/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Observable } from 'rxjs';

export abstract class LegalEntityValidationService {
  abstract exists(country: string, uniqueIdentificationNumber: string): Observable<boolean>;
}
